<template>
  <div
    id="addBadge"
    class="tab-pane "
    role="tabpanel"
  >
    <!-- .serial_nom -->
    <b-form-group
      id="input-group-1"
      :label="$t('invoice.serial_nom')"
      label-for="input-1"
    >
      <b-form-input
        id="input-1"
        v-model="newItem.serial_nom"
        type="text"
        :placeholder="$t('invoice.serial_nom')"
      />
    </b-form-group>
    <!-- .user -->
    <b-form-group
      id="input-group-2"
      :label="$t('invoice.user')"
      label-for="input-2"
    >
      <Select2
        id="input-2"
        v-model="newItem.user"
        :options="userOptions"
      />
    </b-form-group>        <!-- .payment_amount -->
    <b-form-group
      id="input-group-3"
      :label="$t('invoice.payment_amount')"
      label-for="input-3"
    >
      <b-form-input
        id="input-3"
        v-model="newItem.payment_amount"
        type="text"
        :placeholder="$t('invoice.payment_amount')"
      />
    </b-form-group>
    <!-- .payment_type -->
    <b-form-group
      id="input-group-4"
      :label="$t('invoice.payment_type')"
      label-for="input-4"
    >
      <b-form-input
        id="input-4"
        v-model="newItem.payment_type"
        type="text"
        :placeholder="$t('invoice.payment_type')"
      />
    </b-form-group>
    <!-- .invoice_date -->
    <b-form-group
      id="input-group-5"
      :label="$t('invoice.invoice_date')"
      label-for="input-5"
    >
      <b-form-input
        id="input-5"
        v-model="newItem.invoice_date"
        type="text"
        :placeholder="$t('invoice.invoice_date')"
      />
    </b-form-group>
    <!-- .payment_date -->
    <b-form-group
      id="input-group-6"
      :label="$t('invoice.payment_date')"
      label-for="input-6"
    >
      <b-form-input
        id="input-6"
        v-model="newItem.payment_date"
        type="text"
        :placeholder="$t('invoice.payment_date')"
      />
    </b-form-group>
    <!-- .is_paied -->
    <b-form-group
      id="input-group-7"
      :label="$t('invoice.is_paied')"
      label-for="input-7"
    >
      <b-form-input
        id="input-7"
        v-model="newItem.is_paied"
        type="text"
        :placeholder="$t('invoice.is_paied')"
      />
    </b-form-group>
    <!-- .invoiceable -->
    <b-form-group
      id="input-group-8"
      :label="$t('invoice.invoiceable')"
      label-for="input-8"
    >
      <Select2
        id="input-8"
        v-model="newItem.invoiceable"
        :options="invoiceableOptions"
      />
    </b-form-group>        <!-- .invoiceable_type -->
    <b-form-group
      id="input-group-9"
      :label="$t('invoice.invoiceable_type')"
      label-for="input-9"
    >
      <b-form-input
        id="input-9"
        v-model="newItem.invoiceable_type"
        type="text"
        :placeholder="$t('invoice.invoiceable_type')"
      />
    </b-form-group>
    <!-- .installment -->
    <b-form-group
      id="input-group-10"
      :label="$t('invoice.installment')"
      label-for="input-10"
    >
      <b-form-input
        id="input-10"
        v-model="newItem.installment"
        type="text"
        :placeholder="$t('invoice.installment')"
      />
    </b-form-group>

    <div class="form-group">
      <button
        type="button"
        class="btn btn-primary"
        @click="submit()"
      >
        <i class="fa fa-plus" /> {{ $t('site.save') }}
      </button>
    </div>
  </div>
</template>

<script>
import Select2 from 'v-select2-component'
import Controller from '../../../../Controllers/InvoiceController'
import config from '../../../../config/config'

const controller = new Controller()
export default {
  name: 'InvoiceForm',
  components: {
    Select2,
  },
  props: ['newItem'],
  data() {
    return {
      file: {},
      
      user: [],
      invoiceable: [],

    }
  },
  methods: {
       goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      controller.From(this.newItem, 'FormData')
    },
    // async created() {
    //    const data = await controller.created();
    //    data.
    // },

  },

}
</script>
